import { useTranslation, Trans } from "react-i18next";

/**
 * Help page component explaining how to download completed files.
 *
 * @component
 */
function HelpPageDownloading() {
  const { t } = useTranslation("modals");

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h2 className="text-xl font-semibold">{t("sheetagent.help.downloading.title")}</h2>
        <p className="text-sm text-muted-foreground">
          {t("sheetagent.help.downloading.description")}
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.downloading.whenreadytitle")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed mb-2">
            {t("sheetagent.help.downloading.whenreadydescription")}
          </p>
          <ol className="list-decimal list-inside text-sm text-muted-foreground space-y-1 ml-2">
            <li>
              <Trans
                i18nKey="sheetagent.help.downloading.step1"
                ns="modals"
                components={{
                  strong: <strong className="text-foreground" />,
                }}
              />
            </li>
            <li>{t("sheetagent.help.downloading.step2")}</li>
            <li>{t("sheetagent.help.downloading.step3")}</li>
            <li>{t("sheetagent.help.downloading.step4")}</li>
          </ol>
        </div>

        <div className="space-y-2">
          <h3 className="text-lg font-medium">{t("sheetagent.help.downloading.whatyougettitle")}</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {t("sheetagent.help.downloading.whatyougetdescription")}
          </p>
        </div>
      </div>

      <div className="p-4 bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-md">
        <p className="text-sm text-blue-900 dark:text-blue-100">
          <strong className="font-medium">{t("sheetagent.help.downloading.remembertitle")}</strong>{" "}
          {t("sheetagent.help.downloading.remembercontent")}
        </p>
      </div>
    </div>
  );
}

export default HelpPageDownloading;
